
    import Index from   "./_Index.vue"  
    import { Options, Vue } from "vue-class-component";   
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "RelatorioPagamento",
        components: { Index },  
    }) 
    export default class RelatorioPagamento extends Vue { 

        @authStore.Getter
		public perfis!: any  
 
    }
